
const AccordionIcon = (props) => {
    const { classes } = props;
    return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="14.767" height="9.763" viewBox="0 0 14.767 9.763">
            <g id="Drop_Down" dataname="Drop Down">
                <path id="Path" d="m0 0 5.977 7.357L11.953 0" transform="rotate(180 6.68 4.178)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            </g>
        </svg>
    )
};

export default AccordionIcon